
import './LoginView.css';
import 'bootstrap/dist/css/bootstrap.css';
import ContentGrid from './Components/ContentGrid/ContentGrid';
import LogoColumn from './Components/LogoColumn/LogoColumn';
import LoginMsgColumn from './Components/LoginMsgColumn/LoginMsgColumn';
import LoginFormColumn from './Components/LoginFormColumn/LoginFormColumn';
import MobileContentGrid from './Components/MobileContentGrid/MobileContentGrid';
import TopGridContent from './Components/TopGridContent/TopGridContent';
import MidGridContent from './Components/MidGridContent/MidGridContent';
import BottomGridContent from './Components/BottomGridContent/BottomGridContent';

const LoginView = ({ loginAction }) => {

  const screenWidth = () => {
    
    if(window.innerWidth <= 420){
      return false;
    }
      return true;
  }

  console.log(window.innerWidth);

  return (
    <div className="loginview">
      

      {screenWidth() ? 
        <ContentGrid left={<LogoColumn />} mid={<LoginMsgColumn />} right={<LoginFormColumn formAction={loginAction}/>} /> :
        <MobileContentGrid top={<TopGridContent />} mid={<MidGridContent />} bottom={<BottomGridContent formAction={loginAction}/>} />
      }

      
    </div>
  );
}

export default LoginView;
